import React from 'react';
import { ShimmerCircularImage, ShimmerTitle, ShimmerThumbnail } from "react-shimmer-effects";

const LatestObservationLoader = () => {
  return (
    <>
      <div className="d-flex">
        <div className="d-flex align-items-center">
          <ShimmerCircularImage size={30} className="flex-1 mg-b-0" />
          <div style={{ width: '130px' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-l-10 mg-b-0 d-block" /></div>
        </div>
      </div>
      <ShimmerTitle line={2} gap={5} variant="primary" className="mg-t-15 mg-b-0" />
      <div className="mg-t-10 d-flex mx-n-4">
        <div className="pd-x-4 col-2"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-2"><ShimmerThumbnail height={24} className="rounded-3 mb-0" /></div>
      </div>
      <div className="mg-t-18 d-flex mx-n-4">
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={60} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={60} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={60} className="rounded-3 mb-0" /></div>
        <div className="pd-x-4 col-3"><ShimmerThumbnail height={60} className="rounded-3 mb-0" /></div>
      </div>
    </>
  );
};

export default LatestObservationLoader;
